{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "spending": {
    "label": "Limite de dépenses de l'équipe",
    "summary": "{{spent}} dépensés / {{limit}} par mois",
    "noLimit": "{{spent}} dépensés · aucune limite définie"
  },
  "tabs": {
    "stores": "Boutiques ({{count}})",
    "members": "Membres ({{count}})"
  },
  "stores": {
    "title": "Boutiques affectées",
    "assign": "Affecter des boutiques",
    "empty": "Aucune boutique affectée pour le moment"
  },
  "store": {
    "Connected": "Connectée",
    "Disconnected": "Déconnectée",
    "remove": "Retirer"
  },
  "members": {
    "empty": "Aucun membre dans cette équipe pour le moment"
  },
  "assign": {
    "title": "Affecter des boutiques à l'équipe",
    "subtitle": "Sélectionnez les boutiques que cette équipe doit voir. Cela remplace la sélection actuelle.",
    "unassignedBadge": "Non affectée",
    "save": "Enregistrer",
    "saving": "Enregistrement..."
  },
  "toast": {
    "storesAssigned": "Boutiques affectées",
    "storeRemoved": "Boutique retirée",
    "assignFailed": "Impossible de mettre à jour l'affectation des boutiques",
    "staleConflict": "L'affectation a changé depuis son ouverture — actualisation. Veuillez vérifier et réessayer.",
    "crossTeamConflict": "« {{store}} » appartient déjà à une autre équipe. Retirez-la d'abord de celle-ci."
  },
  "empty": {
    "notFound": {
      "title": "Équipe introuvable",
      "body": "Cette équipe a peut-être été désactivée ou le lien n'est pas valide.",
      "back": "Retour aux Équipes"
    }
  },
  "error": {
    "loadFailed": "Impossible de charger cette équipe.",
    "retry": "Réessayer",
    "forbidden": {
      "title": "Accès refusé",
      "body": "Vous n'avez pas la permission de voir cette équipe. Contactez le propriétaire de la boutique."
    }
  }
}
